const { find } = require('lodash');

class PastShopService {
    constructor($q, $location, restangular, bootstrap, listProductService) {
        this.api = restangular.one('pastshops');
        this.$q = $q;
        this.$location = $location;
        this.listProductService = listProductService;
        this.pastShops = [];

        // Promise used to cache past shops
        this.pastShopPromise = null;

        if (bootstrap.isBootstrapped(bootstrap.bootstrapped.PastShops)) {
            this.pastShopPromise = this.$q.when(this.setPastShops(bootstrap.getBootstrappedData(bootstrap.bootstrapped.PastShops)));
        }
    }

    setPastShops(data) {
        this.pastShops = data.Response;
        return this.pastShops;
    }

    invalidateCache() {
        // This will reset the past shops promise to fetch from the API. This is needed when the
        // result is unpredictable / impractial to determine using the frontend only.
        this.pastShopPromise = null;
        return this.listPastShops();
    }

    listPastShops() {
        if (!this.pastShopPromise) {
            // Cache has been invalidated, fetch from API
            this.pastShopPromise = this.api.one('list').get().then(data => this.setPastShops(data));
        }
        return this.pastShopPromise;
    }

    getOrder(orderId) {
        return this.listPastShops().then(pastShops => this.$q.when(find(pastShops, pastShop => pastShop.OrderId === orderId)));
    }

    getProducts(orderId, pageSize, pageNumber, sortType, filters) {
        return this.api.post(orderId === 'everything' ? 'AllProducts' : `${orderId}/Products`, {
            PageNumber: pageNumber,
            PageSize: pageSize || 10,
            SortType: sortType,
            Location: this.$location.url(),
            Filters: filters ? filters.filters : [],
        });
    }
}

PastShopService.$inject = ['$q', '$location', 'Restangular', 'BootstrapService', 'ListProductService'];

module.exports = PastShopService;



// WEBPACK FOOTER //
// ./src/common/pastshops/pastshop.service.js